export type PropertySort = "newest" | "price-asc" | "price-desc" | "rooms-asc" | "rooms-desc";

type SortableProperty = {
  preis?: string;
  zimmer?: string;
};

export function parsePropertyPrice(value?: string): number | null {
  const digits = (value ?? "").replace(/[^0-9]/g, "");
  if (!digits) return null;

  const parsed = Number(digits);
  return Number.isFinite(parsed) ? parsed : null;
}

export function parsePropertyRooms(value?: string): number | null {
  const normalized = (value ?? "").replace(",", ".");
  const match = normalized.match(/\d+(?:\.\d+)?/);
  if (!match) return null;

  const parsed = Number(match[0]);
  return Number.isFinite(parsed) ? parsed : null;
}

export function sortProperties<T extends SortableProperty>(properties: T[], sort: PropertySort): T[] {
  if (sort === "newest") return [...properties];

  const field = sort.startsWith("price") ? "preis" : "zimmer";
  const direction = sort.endsWith("desc") ? -1 : 1;
  const parser = field === "preis" ? parsePropertyPrice : parsePropertyRooms;

  return [...properties].sort((left, right) => {
    const leftValue = parser(left[field]);
    const rightValue = parser(right[field]);

    if (leftValue === null && rightValue === null) return 0;
    if (leftValue === null) return 1;
    if (rightValue === null) return -1;
    return (leftValue - rightValue) * direction;
  });
}
